<div class="sms-builder row">
  <mat-card class="col col-xs-12 col-md-6">
    <mat-card-content>
      <sms-builder-form
        [allowDynamic]="allowDynamic"
        [setInitialInputText]="initialInputText"
        (template)="updateSMS($event)"
        (valid)="updateValid($event)"
      ></sms-builder-form>
    </mat-card-content>
  </mat-card>
  <div class="col col-xs-12 col-md-6">
    <sms-builder-preview [allowDynamic]="allowDynamic" [messageText]="(sms$ | async).message"></sms-builder-preview>
  </div>
</div>
